// src/module/format/date/index.ts
function dateToDateString(input) {
  if (!input) {
    return void 0;
  }
  if (typeof input === "string") {
    if (isValidDateString(input) || isValidDateTimeString(input)) {
      return input.substring(0, 0 + 10);
    }
    return void 0;
  }
  return [input.getFullYear(), input.getMonth() + 1, input.getDate()].map((v) => `${v}`.padStart(2, "0")).join("-");
}
function dateToTimeString(input, precision = "m") {
  if (!input) {
    return void 0;
  }
  if (typeof input === "string") {
    if (!isValidDateTimeString(input)) {
      return void 0;
    }
    switch (precision) {
      case "m":
        return input.substring(11, 11 + 5) || void 0;
      case "s":
        return input.substring(11, 11 + 8) || void 0;
      case "ms":
      default:
        return input.substring(11, 11 + 12) || void 0;
    }
  }
  const [h, m, s] = [input.getHours(), input.getMinutes(), input.getSeconds()].map((v) => `${v}`.padStart(2, "0"));
  switch (precision) {
    case "m":
      return `${h}:${m}`;
    case "s":
      return `${h}:${m}:${s}`;
    case "ms":
    default:
      return `${h}:${m}:${s}.${input.getMilliseconds()}`;
  }
}
function dateTimeStringsToDate({
  date,
  time,
  timezone
}) {
  if (typeof date === "undefined" && typeof time === "undefined") {
    return;
  }
  const _dateString = date ?? dateToDateString(/* @__PURE__ */ new Date());
  const _timeString = time ?? "00:00";
  return /* @__PURE__ */ new Date(`${_dateString}T${_timeString}${timezone === "UTC" ? "Z" : ""}`);
}
function isValidDateTimeString(input) {
  if (typeof input === "undefined") {
    return false;
  }
  let [date, time] = input.split("T");
  time = time?.replace(/(Z)|((\+|-)\d{2}:\d{2})$/gm, "");
  return isValidDateString(date) && isValidTimeString(time);
}
function isValidDateString(input) {
  if (typeof input === "undefined" || input === null) {
    return false;
  }
  const parts = input.split("-");
  if (parts.length !== 3) {
    return false;
  }
  const [y, m, d] = parts;
  if (!(y.length === 4 && +y > 0)) {
    return false;
  }
  if (!(m.length === 2 && +m > 0 && +m <= 12)) {
    return false;
  }
  if (!(d.length === 2 && +d > 0 && +d <= 31)) {
    return false;
  }
  return true;
}
function isValidTimeString(input) {
  if (typeof input === "undefined" || input === null) {
    return false;
  }
  if (input.match(/(Z)|((\+|-)\d{2}:\d{2})$/gm) !== null) {
    return false;
  }
  const parts = input.split(":");
  if (
    // inline type-guard
    !((p) => {
      return p.length === 2 || p.length === 3;
    })(parts)
  ) {
    return false;
  }
  const [h, m, _s] = parts;
  if (!(h.length === 2 && +h < 24)) {
    return false;
  }
  if (!(m.length === 2 && +m < 60)) {
    return false;
  }
  if (_s) {
    const [s, ms] = _s.split(".");
    if (!(s.length === 2 && +s < 60)) {
      return false;
    }
    if (ms) {
      if (!(ms.length === 3 && +ms < 1e3)) {
        return false;
      }
    }
  }
  return true;
}
function offsetTime(time, offsetMinutes) {
  if (!isValidTimeString(time)) {
    throw new Error("Invalid time");
  }
  const [h, m] = time.split(":").map((v) => Number(v));
  const originalMinutes = h * 60 + m;
  let newMinutes = originalMinutes + offsetMinutes;
  const DAY = 24 * 60;
  let dayOffset = 0;
  if (newMinutes < 0) {
    newMinutes = DAY + newMinutes;
    dayOffset = -1;
  } else if (newMinutes >= DAY) {
    newMinutes = newMinutes - DAY;
    dayOffset = 1;
  }
  const min = newMinutes % 60;
  const hour = (newMinutes - min) / 60;
  return {
    time: [hour, min].map((v) => `${v}`.padStart(2, "0")).join(":"),
    dayOffset
  };
}

export { dateTimeStringsToDate, dateToDateString, dateToTimeString, isValidDateString, isValidDateTimeString, isValidTimeString, offsetTime };
